export default __webpack_public_path__ + "static/media/flower-bottom.3615ede6.png";